import { fetchUserLogs, changePage } from '#action/user/log';
import { ProjectsFilterOptionService, UserFilterOptionService, ActionTypeFilterOptionService } from '#service/autocomplete-service/service';
import { uuidv4 } from '#helper';
import { userEventType } from '#type';

const projectComponent = {
  type: 'SelectWithCounter',
  name: 'project',
  label: 'Project',
  relatedTo: 'user-log',
  id: uuidv4(),
  fetchOptionsService: ProjectsFilterOptionService,
  searchFields: ['title']
};

const filterUserComponent = {
  type: 'SelectWithCounter',
  name: 'targetUser',
  label: 'User',
  relatedTo: 'user-log',
  id: uuidv4(),
  fetchOptionsService: UserFilterOptionService,
  searchFields: ['fullName']
};

const filterActorComponent = {
  type: 'SelectWithCounter',
  name: 'user',
  label: 'Actor',
  relatedTo: 'user-log',
  id: uuidv4(),
  fetchOptionsService: UserFilterOptionService,
  searchFields: ['fullName']
};

const actionTypeSelect = {
  type: 'SelectWithCounter',
  name: 'event',
  label: 'Action',
  relatedTo: 'user-log',
  id: uuidv4(),
  fetchOptionsService: ActionTypeFilterOptionService,
  optionServiceConfig: { eventTypes: userEventType },
  searchFields: ['label']
};

const filterConfig = {
  disableSync: true,
  customActions: {
    fetchFilterData: fetchUserLogs,
    changePage
  },
  dateRangeComponent: true,
  components: [projectComponent, filterUserComponent, filterActorComponent, actionTypeSelect]
};

export default filterConfig;
